var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rbInputFileContainer box",
      class: {
        "has-advanced-upload": _vm.hasAdvancedUpload,
        "is-dragging": _vm.dragging,
      },
    },
    [
      _c("input", {
        attrs: { type: "file", accept: _vm.accept, name: _vm.name },
        on: { change: _vm.choseFiles },
      }),
      !_vm.uploaded
        ? _c(
            "div",
            {
              staticClass: "box__input",
              on: {
                drag: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.noop.apply(null, arguments)
                },
                dragstart: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.noop.apply(null, arguments)
                },
                dragover: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.dragBegin.apply(null, arguments)
                },
                dragenter: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.dragBegin.apply(null, arguments)
                },
                dragleave: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.dragStop.apply(null, arguments)
                },
                dragend: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.dragStop.apply(null, arguments)
                },
                drop: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.drop.apply(null, arguments)
                },
              },
            },
            [
              !(_vm.dragging || _vm.uploading || _vm.uploaded)
                ? _c("label", [
                    _c("div", { staticClass: "box__dragndrop" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("cloud_upload"),
                      ]),
                      _c("div", [
                        _vm._v("Drag and Drop Image File Here to Upload"),
                      ]),
                      _c("div", { staticClass: "box__error" }, [
                        _vm._v(_vm._s(_vm.loadError)),
                        _c("br"),
                        _vm._v(_vm._s(_vm.vvError ? _vm.vvError : "")),
                        _c("span"),
                      ]),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "manual-upload",
                        attrs: { type: "button" },
                        on: { click: _vm.chooseFiles },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.hasAdvancedUpload ? "Or" : "") +
                            " Select File Manually "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.dragging || _vm.uploading
                ? _c(
                    "div",
                    {
                      class: {
                        box__dragging: true,
                        dragging: _vm.dragging,
                        uploading: _vm.uploading,
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add_a_photo"),
                      ]),
                      _vm.dragging
                        ? _c("div", [_vm._v("Drop File Here")])
                        : _vm._e(),
                      _vm.uploading
                        ? _c(
                            "div",
                            [
                              _c("rb-loading", {
                                attrs: { "rb-class": "medium" },
                              }),
                              _vm._v(
                                " Uploading File " +
                                  _vm._s(_vm.loadPercentage) +
                                  "% "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.uploading
        ? _c("rb-progress", { attrs: { max: 100, value: _vm.loadPercentage } })
        : _vm._e(),
      _vm.uploaded && _vm.accept === "image/*"
        ? _c("rb-croppie", {
            attrs: { url: _vm.fileUrl, options: _vm.croppieOptions },
            on: { change: _vm.croppieChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }